module.exports = __webpack_public_path__ + "static/media/homeTitle4.eee00865.png";